<template>
    <b-pagination-nav use-router :link-gen="linkGen" :value="page" :number-of-pages="meta.totalPage" />
</template>

<script>
import { BPaginationNav } from "bootstrap-vue";

export default {
    name: "Pagination",
    components: { "b-pagination-nav": BPaginationNav },
    props: ["meta", "page", "componentName"],
    data() {
        return {};
    },
    computed: {},
    methods: {
        linkGen(pageNum) {
            return { name: this.componentName, query: this.getLinkParams({ offset: pageNum }) };
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                temp[key] = this.$route.query[key];
            }
            if (x.hasOwnProperty("category")) {
                delete temp.offset;
                delete temp.subcategory;
            } else if (x.hasOwnProperty("type") || x.hasOwnProperty("section")) {
                delete temp.offset;
            }

            for (let key in x) {
                temp[key] = x[key];
            }
            return temp;
        }
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// Pagination.vue?fd9c201c